import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getSurveyConfig } from '../../config/surveys';
import Navbar from '../layout/Navbar';
import './StaffDashboard.css';

const StaffDashboard: React.FC = () => {
  const { user, availableSurvey, completedSurveys } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const surveyId = availableSurvey || null;
  const surveyConfig = surveyId ? getSurveyConfig(surveyId) : null;
  const hasCompleted = surveyId ? completedSurveys.includes(surveyId) : false;

  const handleStartSurvey = () => {
    if (surveyId) {
      navigate(`/survey/${surveyId}`);
    }
  };

  return (
    <>
      <Navbar />
      <div className="staff-dashboard">
        <div className="staff-content">
          {hasCompleted || !surveyConfig ? (
            <>
              <div className="caught-up-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                  <circle cx="40" cy="40" r="36" fill="#e8f5e9" />
                  <path
                    d="M28 40L36 48L52 32"
                    stroke="#34c759"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h1 className="caught-up-title">All Caught Up!</h1>
              <p className="caught-up-message">
                Hi {user.name.split(' ')[0]}, you're all set. There are no surveys available for you at this time.
              </p>
            </>
          ) : (
            <>
              <h1 className="staff-welcome">Hi {user.name.split(' ')[0]}, you have a survey to complete.</h1>
              <div className="staff-survey-card">
                <div className="staff-survey-info">
                  <h2 className="staff-survey-name">{surveyConfig.name}</h2>
                  <p className="staff-survey-description">
                    {surveyConfig.metadata?.description || 'Share your feedback'}
                  </p>
                  {surveyConfig.metadata?.estimatedMinutes && (
                    <p className="staff-survey-time">
                      Estimated time: {surveyConfig.metadata.estimatedMinutes} minutes
                    </p>
                  )}
                </div>
                <button className="staff-start-btn" onClick={handleStartSurvey}>
                  Start Survey
                </button>
              </div>
            </>
          )}

          <div className="staff-info-card">
            <div className="info-row">
              <span className="info-label">School</span>
              <span className="info-value">{user.schoolName || 'Not assigned'}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Role</span>
              <span className="info-value capitalize">{user.role}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffDashboard;
